import React, { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import StarField from '../components/StarField';
import styles from './Landing.module.css';

export default function Landing() {
  const { dispatch } = useApp();
  const [exiting, setExiting] = useState(false);
  const [activeNav, setActiveNav] = useState('home');
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // 入场动画延迟
    setTimeout(() => setLoaded(true), 100);
  }, []);

  const handleEnter = () => {
    setExiting(true);
    setTimeout(() => dispatch({ type: 'SET_PAGE', payload: 'intro' }), 1200);
  };

  const handleNavClick = (key) => {
    setActiveNav(key);
    if (key === 'test') {
      handleEnter();
    } else if (key === 'explore') {
      dispatch({ type: 'SET_PAGE', payload: 'explore' });
    } else if (key === 'gallery') {
      dispatch({ type: 'SET_PAGE', payload: 'gallery' });
    } else if (key === 'live') {
      dispatch({ type: 'SET_PAGE', payload: 'liveHost' });
    }
  };

  const navItems = [
    { key: 'home', label: '首页' },
    { key: 'test', label: '测试' },
    { key: 'explore', label: '探索' },
    { key: 'gallery', label: '黑匣子' },
    { key: 'live', label: '现场模式' },
  ];

  return (
    <div className={`${styles.container} ${exiting ? styles.exiting : ''} ${loaded ? styles.loaded : ''}`}>
      <StarField density={300} />
      
      {/* 导航栏 */}
      <nav className={styles.nav}>
        {navItems.map((item, index) => (
          <button
            key={item.key}
            className={`${styles.navItem} ${activeNav === item.key ? styles.active : ''}`}
            onClick={() => handleNavClick(item.key)}
            style={{ animationDelay: `${0.5 + index * 0.1}s` }}
          >
            {item.label}
          </button>
        ))}
      </nav>

      {/* 左上角标题图片 */}
      <div className={styles.titleSection}>
        <img src="/images/Title.png" alt="畸变星蚀" className={styles.titleImg} />
        <p className={styles.subtitle}>—— 荣格原型的异化星象记录</p>
      </div>

      {/* 左下土星 */}
      <img src="/images/saturn.png" alt="" className={styles.saturnLeft} />

      {/* 右上星球 */}
      <img src="/images/plant-glow.png" alt="" className={styles.planetRight} />

      {/* 底部山脉 */}
      <img src="/images/mountains.png" alt="" className={styles.mountains} />

      {/* 进入按钮 */}
      <button className={styles.enterBtn} onClick={handleEnter}>
        <span className={styles.btnText}>进入人设测试</span>
        <span className={styles.btnGlow}></span>
      </button>
    </div>
  );
}
